import { ErrorOutline } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import colors from "../../../config/colors";

interface HomeErrorStateProps {
	onRetry: () => void;
}

function HomeErrorState({ onRetry }: HomeErrorStateProps) {
	const { t } = useTranslation();

	return (
		<Box
			sx={{
				padding: "80px 24px",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				gap: 1.75,
				textAlign: "center",
			}}
		>
			<ErrorOutline sx={{ fontSize: "48px", color: colors.error }} />
			<Typography sx={{ fontSize: "1.25rem", fontWeight: 500 }}>
				{t("supervisor-home_error-title")}
			</Typography>
			<Typography
				sx={{ fontSize: "14px", color: colors.gray, maxWidth: "420px" }}
			>
				{t("supervisor-home_error-description")}
			</Typography>
			<Button variant='contained' onClick={onRetry}>
				{t("supervisor-home_try-again")}
			</Button>
		</Box>
	);
}

export default HomeErrorState;
